import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { SiPaypal, SiMercadopago } from 'react-icons/si';

// Sello de confianza con los medios de pago aceptados. Solo mostramos las
// DOS pasarelas que realmente están integradas (Mercado Pago y PayPal) —
// Visa/Mastercard no son opciones separadas, son tarjetas que Mercado Pago
// procesa por dentro, así que van como nota al pie en vez de un logo aparte.
//
// Los íconos son de react-icons/si (basado en simple-icons, open source),
// en el color oficial de cada marca. No son los archivos de marca 100%
// oficiales de Mercado Pago/PayPal (esos solo se pueden bajar desde el
// panel de comercio de cada uno, una vez que Augusto tenga cuenta activa) —
// apenas los tengamos, se reemplazan acá por los reales.
const METHODS = [
  { Icon: SiMercadopago, name: 'Mercado Pago', color: '#00B1EA' },
  { Icon: SiPaypal, name: 'PayPal', color: '#002991' },
];

const PaymentMethodsBadges = ({ label, sx }) => (
  <Box sx={{ textAlign: 'center', ...sx }}>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
      {label}
    </Typography>
    <Stack direction="row" spacing={2} justifyContent="center" flexWrap="wrap" useFlexGap alignItems="center">
      {METHODS.map(({ Icon, name, color }) => (
        <Box
          key={name}
          title={name}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 60,
            height: 42,
            borderRadius: 1.5,
            bgcolor: '#fff',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 1,
          }}
        >
          <Icon size={28} color={color} aria-label={name} />
        </Box>
      ))}
    </Stack>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
      Mercado Pago procesa tarjetas Visa y Mastercard
    </Typography>
  </Box>
);

export default PaymentMethodsBadges;
